<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            Relatório Time Line -
                            <strong>{{ convenio.vcCodigoEstruturado }}</strong>
                            <b-badge variant="warning" class="ml-2">{{operacao}}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                            <template>
                                <div>
                                    <div class="fixed-info">
                                        <h1>Informações do Convênio</h1>
                                        <div class="info-section">
                                            <div class="info-item"><strong>Nº do Convênio:</strong> {{ convenio.vcCodigoEstruturado }}</div>
                                            <div class="info-item"><strong>Vigência:</strong>
                                            {{
                                                convenio.dtInicioVigencia
                                                    ? $moment(convenio.dtInicioVigencia).format(
                                                        'DD/MM/YYYY'
                                                    )
                                                    : ''
                                            }}
                                            <span v-if="convenio.dtInicioVigencia">a</span>
                                            {{
                                                convenio.dtFimVigencia
                                                    ? $moment(convenio.dtFimVigencia).format(
                                                        'DD/MM/YYYY'
                                                    )
                                                    : ''
                                            }}
                                            </div>
                                            <div class="info-item" v-if="convenio.processoAta"><strong>Nº do Processo:</strong> {{convenio.processoAta.nuProcesso}}</div>
                                            <div class="info-item"><strong>Gestor:</strong> {{convenio.gestor.nome}}</div>
                                            <div class="info-item" v-if="convenio.convenenteRM"><strong>Convenente:</strong> {{convenio.convenenteRM.cnpj}} | {{convenio.convenenteRM.nome}} </div>
                                            <div class="info-item"><strong>Unidade:</strong> {{ convenio.unidade.nome }}</div>
                                            <div class="info-item"><strong>Valor Total Convênio:</strong>
                                            {{
                                                convenio.nuValorConvenio | currency
                                            }}
                                            </div>
                                            <div class="info-item"><strong>Situação:</strong> {{ convenio.situacaoConvenio }}</div>
                                            <div class="info-item"><strong>Objetivo:</strong> {{ convenio.vcObjeto }}</div>
                                        </div>
                                    </div>
                                    <detalhes-prestacao-contas-mensal
                                        :convenio="convenio"
                                        :prestacoes="prestacoes"
                                        :tempoTotalEncerramentoEmDias="tempoTotalEncerramentoEmDias"
                                        :itemtimeLine="itensTimeLine"
                                        :tempoMedioEntreEtapas="tempoMedioEntreEtapas"
                                        :prazoTotalEncerramento="prazoTotalEncerramento"

                                        >
                                    </detalhes-prestacao-contas-mensal>
                                    <detalhes-resumo-consolidado
                                        :convenio="convenio"
                                        :prestacoes="prestacoes"
                                        :prestacoesContasFinal="prestacoesContasFinal"
                                        :prazoTotalMedio="prazoTotalMedio"
                                        :tempoMedioEntreEtapas="tempoMedioEntreEtapas"
                                        :periodoDuracaoInicial="periodoDuracaoInicial"
                                        :periodoDuracaoFinal="periodoDuracaoFinal"
                                        :duracaoTotal="duracaoTotal"
                                        :quantidadePrestacoesContas="quantidadePrestacoesContas"
                                        >
                                    </detalhes-resumo-consolidado>
                                    <div class="footer">
                                    <p>Relatório gerado em {{ dataGeracao }} às {{ horaGeracao }}</p>
                                    <p>Este documento é parte integrante do convênio {{ convenio.vcCodigoEstruturado }}.</p>
                                    </div>
                                </div>
                            </template>
                    </b-card-body>
                    <b-card-footer>
                        <app-btn-voltar></app-btn-voltar>
                        <b-button
                            variant="primary"
                            @click.stop="emitirRelatorioTimeLine()"
                            class="ml-2">
                            <span>
                                <i class="fa fa-file mr-2"></i> Emitir Relatório PDF
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import RelatorioServicos from './RelatoriosServicos'
    import ConveniosServicos from './ConveniosServicos'
    import DetalhesPrestacaoContasMensal from './DetalhesTimeLinePrestacaoContasMensal'
    import DetalhesResumoConsolidado from './DetalhesResumoConsolidado'

    export default {

        components: {
            RelatorioServicos,
            DetalhesPrestacaoContasMensal,
            DetalhesResumoConsolidado
        },

        data() {
            return {
                convenio: null,
                prestacoes: [],
                erros: [],
                dataGeracao: '',
                horaGeracao: '',
                idConvenio: 0,
                prazoTotalMedio: '',
                periodoDuracaoInicial: '',
                periodoDuracaoFinal: '',
                duracaoTotal: '',
                tempoMedioEntreEtapas: '',
                tempoTotalEncerramentoEmDias : '',
            }
        },

        methods: {
            obterConvenio() {
                this.$store.dispatch('addRequest');
                return ConveniosServicos.ObterConvenioPorId(this.$route.params.idConvenio)
                .then(response => {
                    if (response && response.success) {
                    this.convenio = response.data;
                    this.idConvenio = this.convenio.idConvenio;
                    this.prazoTotalMedio = this.convenio.prazoTotalMedio;
                    this.periodoDuracaoInicial = response.data.periodoDuracaoInicio;
                    this.periodoDuracaoFinal = response.data.periodoDuracaoFim;
                    this.duracaoTotal = response.data.duracaoTotal;
                    this.prazoTotalEncerramento = response.data.prazoTotalEncerramento;

                    } else {
                    this.erros = response.errors;
                    }
                    this.$store.dispatch('removeRequest');
                });
            },

            carregarListaPrestacoes() {
                this.$store.dispatch('addRequest');
                return ConveniosServicos.ListarPrestacoesContasTimeLine(this.convenio.idConvenio)
                .then(response => {
                    if (response && response.success) {
                        this.prestacoes = response.data;
                        this.quantidadePrestacoesContas = this.prestacoes.length;
                        this.prestacoesContasFinal = this.prestacoes.prestacoesContasFinal;
                        this.tempoTotalEncerramentoEmDias = response.data.tempoTotalEncerramentoEmDias;
                        this.tempoMedioEntreEtapas = response.data.tempoMedioEntreEtapas;
                    } else {
                    this.erros = response.errors;
                    }
                    this.$store.dispatch('removeRequest');
                });
            },

            emitirRelatorioTimeLine() {
            this.$store.dispatch('addRequest')
            RelatorioServicos.EmitirRelatorioTimeLine('timeline', this.idConvenio).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'portimeline.pdf')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            },

        },

        mounted() {
            this.obterConvenio()
                .then(() => {
                this.carregarListaPrestacoes();
                });

            this.dataGeracao = new Date().toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });


            this.horaGeracao = new Date().toLocaleString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });

        }
    }
</script>

<style scoped>
.fixed-info h1 {
  background-color: #f9f9f9;
  margin: 0;
  padding: 15px;
  font-size: 1.5em;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.fixed-info {
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
}

.fixed-info .info-section {
  background-color: #ffffff;
  padding: 15px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 10px;
}

.fixed-info .info-item {
  font-size: 1em;
}

.fixed-info .info-item strong {
  font-weight: bold;
}

.footer {
  margin-top: 30px;
  font-size: 0.9em;
  color: #666;
  text-align: center;
}
</style>
